import { getAbsoluteUrl } from "./urls";
import { fetchAuthenticated } from "./utils";

export interface SifenReportOptions {
  issue?: string;
  templateId?: string;
  details?: string;
}

export interface SifenReportDraft {
  issue: string;
  templateId: string;
  issues: { id: string; label: string }[];
  subject: string;
  text: string;
  attachments: string[];
  archiveFilename?: string;
}

export const downloadSifenReport = async (baseUrl: string, options: SifenReportOptions): Promise<Blob> => {
  const response = await fetchAuthenticated(getAbsoluteUrl(`${baseUrl}/attachments/`), {
    method: "POST",
    credentials: "include",
    headers: { Accept: "application/zip", "Content-Type": "application/json" },
    body: JSON.stringify(options),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => undefined);
    throw new Error(error?.detail || "No se pudo descargar el ZIP de respaldo.");
  }
  return response.blob();
};
